export const UNAPPOINTED_PROS_CONTENT = {
  gridTitle: 'Shipments',
  helperText:
    'Select the pros you want to move to the city route before running Optymizer. Pros are unselected by default; unselected pros will stay in the unappointed bucket.'
};
